// extracted by mini-css-extract-plugin
export default {"content":"GgIHC","search-section":"R0KPX"};